import { useState } from "react";
import { AIGeneratedTextarea } from "./AIGeneratedTextarea";
import { AICommentModal } from "./AICommentModal";

/**
 * Self-contained drop-in that replaces the duplicated handleGenerateAI pattern.
 * Renders an AIGeneratedTextarea whose button opens the AI comment modal.
 *
 * Props:
 *   config           - { systemPrompt: string, getStudentReportInfo: (formValues) => object }
 *   form             - react-hook-form UseFormReturn instance
 *   fieldName        - form field name for the comment textarea
 *   reportId         - passed to the backend
 *   label            - textarea label text
 *   placeholder      - optional textarea placeholder
 *   labelClassName   - optional className for the label
 *   textareaClassName - optional className for the textarea
 *   buttonClassName  - optional className for the AI button
 */
export function AICommentButton({
  config,
  form,
  fieldName,
  reportId,
  label,
  placeholder,
  labelClassName,
  textareaClassName,
  buttonClassName,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [snapshot, setSnapshot] = useState({ studentReportInfo: {}, currentComment: "" });

  const handleOpenModal = () => {
    // Capture current form state at click time so the modal shows accurate data
    setSnapshot({
      studentReportInfo: config.getStudentReportInfo(form.getValues()),
      currentComment: form.getValues()[fieldName] || "",
    });
    setModalOpen(true);
  };

  const handleCommentGenerated = (comment) => {
    form.setValue(fieldName, comment);
    setModalOpen(false);
  };

  return (
    <>
      <AIGeneratedTextarea
        control={form.control}
        name={fieldName}
        label={label}
        isGenerating={false}
        onGenerate={handleOpenModal}
        placeholder={placeholder}
        labelClassName={labelClassName}
        textareaClassName={textareaClassName}
        buttonClassName={buttonClassName}
      />
      <AICommentModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        defaultSystemPrompt={config.systemPrompt}
        studentReportInfo={snapshot.studentReportInfo}
        currentComment={snapshot.currentComment}
        reportId={reportId}
        onCommentGenerated={handleCommentGenerated}
      />
    </>
  );
}
